export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/sp-admin.controller.js